/**
 * صفحهٔ اولِ هر کاربر بعد از ورود (v2.169.0).
 *
 * کاربر (۱۴۰۵/۰۸/۱۰): «حسن احمدی وقتی وارد می‌شود مستقیم پیگیریِ رنگرزی باز شود؛ برای بقیه هم انتخاب کنیم چه صفحه‌ای باز
 * شود که «دسترسی ندارید» نیاید. پیش‌فرض اولین صفحه‌ای که دسترسی دارد، ولی قابلِ شخصی‌سازی». انتخاب در «تنظیمات ← کاربران».
 * ترتیبِ این فهرست = ترتیبِ «اولین صفحهٔ در دسترس».
 */
export const HOME_PAGES = [
  { path: "/dashboard", label: "داشبورد", perms: ["dashboard.view"] },
  { path: "/production", label: "ثبت و مدیریت تولید", perms: ["production.view"] },
  { path: "/production/cut", label: "ثبت برش", perms: ["production.view"] },
  { path: "/employees", label: "پرسنل", perms: ["personnel.view"] },
  { path: "/attendance", label: "حضور و غیاب", perms: ["attendance.view"] },
  { path: "/payroll", label: "محاسبه و بستن حقوق", perms: ["payroll.view"] },
  { path: "/finance", label: "حساب و کتاب", perms: ["accounting.view"] },
  { path: "/supply-chain", label: "زنجیره تأمین", perms: ["supply_chain.view"] },
  { path: "/supply-chain/events", label: "فاکتورهای زنجیره تأمین", perms: ["supply_chain.view"] },
  { path: "/dye", label: "پیگیری رنگرزی", perms: ["dye.view"] },
  { path: "/assets", label: "اموال", perms: ["assets.view"] },
  { path: "/reports", label: "گزارش‌ها", perms: ["reports.view"] },
  { path: "/chat", label: "گفتگو", perms: ["notes.view"] },
  { path: "/settings", label: "تنظیمات", perms: ["settings.view"] },
  { path: "/guide", label: "راهنمای برنامه", perms: [] },
];

const allowed = (page, has) => !page.perms.length || page.perms.some(has);

/** صفحه‌هایی که این مجموعه مجوز به آن‌ها دسترسی دارد (برای فهرستِ انتخاب). */
export function pagesFor(has) {
  return HOME_PAGES.filter((p) => allowed(p, has));
}

/** صفحهٔ اول: انتخابِ کاربر (اگر هنوز دسترسی دارد) وگرنه اولین صفحهٔ در دسترس. */
export function homeFor(user, has) {
  const chosen = user?.home_page && HOME_PAGES.find((p) => p.path === user.home_page.split("?")[0]);
  if (chosen && allowed(chosen, has)) return user.home_page;
  return (HOME_PAGES.find((p) => allowed(p, has)) || { path: "/guide" }).path;
}
